module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAABTUlEQVR42pVRu0oEQRBcMBAjudQXamgo4geYCv6BgWAy+5ie7ll3F58oaCremZsYbWKkIhiYngoa+QGCif8gZ/e4u8wJd3ADRdNdPTVFTTDshEA/SmNvIABPm2WfiMAe1wJlWY7x4qHMBLFJ17juRprO+l/TdCQQAd9BbOhAZj6fgN3vE0isXWLygS/cVC62KvRioA2pzH0K3Myke42AWHQLhp54eK2ASl68EkRA2jkhmgXI5wR5nk8qk647J4irQZxlU6HG72DEww+eOBcxZish4MuoAk2QxhTzoaav2mpk7GaTTZbN+D0iTkvvC8hwok7ZVcA3rl0mL/8CpfdQm2fOpOPxr7z/6AQis7Mc8kABfnC9lVfdRWO7PLur+4hFud6LC8cDnStVtFjAbift9rgqipYQ1Zdd/Os7kn7dK3Y3MByFxaLfx2m6MIz/BW8C9FhVraurAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/c-transport_1x.png
// module id = 2289
// module chunks = 0